import { HttpClient, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { APP_CONFIG, Settings } from 'src/app/config/settings';
import { FetchArgs } from 'src/app/shared/models/core';
import { combine } from 'src/app/shared/utilities/route';
import { SaveQualifiedCandidateRemovalsDto } from 'src/app/accountmanagers/models/save-qualified-candidate-removals.model';
import { EmailTracking } from '../models/email-tracking.model';
import { QualifiedCandidate } from '../models/qualified-candidate.model';

@Injectable({
    providedIn: 'root'
})
export class QualifiedCandidatesService {
    private readonly _coreApiPath: string;

    constructor(
        private readonly _httpClient: HttpClient,
        @Inject(APP_CONFIG) private readonly _settings: Settings
    ) {
        this._coreApiPath = combine(this._settings.coreAPIUrl, 'AyaNova');
    }

    getQualifiedCandidates(args: FetchArgs, jobId: number): Observable<QualifiedCandidate[]> {
        let queryParams = new HttpParams();
        queryParams = queryParams.appendAll({
            pageIndex: args.skip,
            pageSize: args.pageSize,
            qualifiedCandidatesFilterType: args.filter?.qualifiedCandidatesFilterType
        });
        const url = `${this._coreApiPath}/job-qualifications/qualified-candidates/${jobId}`;
        return this._httpClient.get<QualifiedCandidate[]>(url, { params: queryParams });
    }

    saveQualifiedCandidateRemovals(model: SaveQualifiedCandidateRemovalsDto): Observable<void> {
        const url = `${this._coreApiPath}/job-qualifications/qualified-candidates-removals`;
        return this._httpClient.post<void>(url, model);
    }

    sendEmail(emailPayload: EmailTracking): Observable<any> {
        const url = `${this._coreApiPath}/job-qualifications/send-email-and-update-tracking`;
        return this._httpClient.post(url, emailPayload);
    }
}
